import { useTranslation } from 'next-i18next';
import React from 'react';
import { PresentationComponentInterface, UiComponentElementInterface } from '../../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import EmptyComponent from '../../../../pageBuilder/EmptyComponent';
import { TitleAndDescription } from '../../../../pageBuilder/TitleAndDescription';
import PresentationCardView from './PresentationCardView';
import PresentationList from './PresentationList';
import PresentationTimeline from './PresentationsTimeline';

const PresentationUiComponent = ({ uiComponent }: UiComponentElementInterface<PresentationComponentInterface>) => {
  const slots = useSelector((state) => state.common.slots);
  const { t } = useTranslation();

  return (
    <>
      <TitleAndDescription component={uiComponent!} />
      {slots && slots.length > 0 ? (
        <div
          className={`flex flex-col m-auto w-full overflow-x-scroll`}
          style={{
            color: uiComponent?.styling?.textColor,
          }}>
          {uiComponent?.template === 'normal' && <PresentationCardView uiComponent={uiComponent} />}
          {uiComponent?.template === 'timeline' && <PresentationTimeline uiComponent={uiComponent} />}
          {uiComponent?.template === 'list' && <PresentationList uiComponent={uiComponent} />}
        </div>
      ) : (
        <EmptyComponent componentName={t('pagebuilder:presentation')} />
      )}
    </>
  );
};

export default PresentationUiComponent;
